import { range, unique, groupByContinuousValues } from '@/libs/collection-utility'

export function generatePageList ({ pagination, blockSize }) {
  const { totalPages, currentPage } = pagination

  const pagesNearFirstPage = Array.from(range(
    1,
    blockSize,
  ))

  const pagesNearCurrentPage = Array.from(range(
    currentPage - Math.floor((blockSize - 1) / 2.0),
    currentPage + Math.ceil((blockSize - 1) / 2.0),
  ))

  const pagesNearLastPage = Array.from(range(
    (totalPages - blockSize) + 1,
    totalPages,
  ))

  const pages = unique([
    ...pagesNearFirstPage,
    ...pagesNearCurrentPage,
    ...pagesNearLastPage,
  ])
  .filter(page => page > 0 && page <= totalPages)

  return groupByContinuousValues(pages)
}

export default { generatePageList }



// WEBPACK FOOTER //
// ./src/components/parts/Pagination.lib.js